import { render } from "./CardEvent.vue?vue&type=template&id=7839334a&scoped=true"
import script from "./CardEvent.vue?vue&type=script&lang=js"
export * from "./CardEvent.vue?vue&type=script&lang=js"

import "./CardEvent.vue?vue&type=style&index=0&id=7839334a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7839334a"]])

export default __exports__